var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockrp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_346_1630)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2926 10.8437C20.2821 10.7051 18.3459 9.8727 16.9309 8.5549L16.5584 8.20803C16.4096 8.06942 16.2234 8 16 8C15.7767 8 15.5904 8.06942 15.4416 8.20803L15.0692 8.5549C13.6171 9.90731 11.7183 10.7048 9.7075 10.8437C9.29792 10.8782 9 11.1905 9 11.572V13.6528C9 18.022 11.5317 22.0793 15.6276 24.2293C15.7392 24.2987 15.8883 24.3333 16 24.3333C16.1488 24.3333 16.2608 24.2987 16.3724 24.2293C20.4683 22.0794 23 18.0221 23 13.6528V11.572C23 11.1905 22.7021 10.8785 22.2925 10.8437H22.2926ZM15.9629 11.7106C16.5959 11.7106 17.1171 12.1961 17.08 12.8204L16.8566 16.8776C16.8195 17.3285 16.4471 17.6751 15.963 17.6751C15.4789 17.6751 15.1067 17.3283 15.0693 16.8776L14.8459 12.8204C14.8459 12.1961 15.33 11.7106 15.963 11.7106H15.9629ZM15.9629 20.6573C15.2929 20.6573 14.7713 20.1718 14.7713 19.5475C14.7713 18.9235 15.2926 18.4377 15.9629 18.4377C16.633 18.4377 17.1545 18.9232 17.1545 19.5475C17.1543 20.1718 16.633 20.6573 15.9629 20.6573Z",
    fill: "#093851"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_346_1630",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockrp);
export default __webpack_public_path__ + "static/media/unlockrp.153d5bb2070cc9c3951364c632078337.svg";
export { ForwardRef as ReactComponent };